import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useAppDispatch } from '@wfp-root-app/store/store';
import { Card, CardDescription, CardTitle } from '@wfp-common/components/card/Card';
import { useNavigate } from '@wfp-common/hooks/useNavigate';

import { windowStorage, WindowStorageToken } from '../windowStorage';
import { Profile } from '../icons/Profile';
import { ActionCreators } from './auth';

const ForbiddenPage: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    useEffect(() => {
        const managerToken = windowStorage.getItem(WindowStorageToken.managerApiToken);
        if (managerToken) {
            navigate('/');
        }
    }, [navigate]);

    return (
        <PageWrapper>
            <Card>
                <Icon>
                    <Profile color={'#ff6b6b'} />
                </Icon>
                <CardTitle>Access Forbidden</CardTitle>
                <CardDescription>
                    {'Your account is expired or inactive.\n Please contact the administrator.'}
                </CardDescription>
                <button
                    className="wfp-btn--primary"
                    onClick={() => dispatch(ActionCreators.logout())}
                    role={'button'}
                    type={'button'}
                >
                    Log Out
                </button>
            </Card>
        </PageWrapper>
    );
};

const PageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Icon = styled.div`
    margin-bottom: 24px;
`;

export default ForbiddenPage;
